/* eslint-disable jira/filename-case */
import type { AnalyticsWebClient } from '@jira/platform__observability-product-analytics-web-client-types';

let markAnalyticsClientAsReady: (client: AnalyticsWebClient) => void;
const analyticsClientPromise: Promise<AnalyticsWebClient> = new Promise(
	(resolve: (result: Promise<AnalyticsWebClient> | AnalyticsWebClient) => void) => {
		markAnalyticsClientAsReady = resolve;
	},
);

// Providing a way to get the analytics client before it's bootstraped to avoid
// race conditions when you need it before AppBase runs
export const getAnalyticsWebClientPromise = (): Promise<AnalyticsWebClient> =>
	analyticsClientPromise;
export const resolveAnalyticsWebClientPromise = (client: AnalyticsWebClient): void =>
	markAnalyticsClientAsReady(client);
